import loadEnvConfig from './environment-loader';
import { IEnvironment } from './types';

export const environment: IEnvironment = Object.freeze(loadEnvConfig());
